import React from "react";
import { Snackbar } from "@mui/material";

// Wrapper to ensure no invalid props are passed to ClickAwayListener
export const FixedSnackbarProvider = (props) => {
  const { ownerState, ...validProps } = props;

  return <Snackbar {...validProps} />;
};
